export default "__VITE_ASSET__24708e6b__"